<div (click)="goBackToSelection()" class="mb-2 text-gray-800 cursor-pointer">
  <i class="fa-regular fa-arrow-left"></i>
  Back to Assistant Selection
</div>
<app-assistant-profile [assistant]="assistant"></app-assistant-profile>
<div class="flex flex-column-reverse w-full flex-grow-1 gap-2">
  <div class="flex flex-row w-full gap-2">
    <input (keydown.enter)="search()" [(ngModel)]="query" class="flex-grow-1" pInputText type="text">
    <button (click)="search()">
      <i class="fa-regular fa-search"></i>
      {{searching ? 'Working' : 'Ask'}}
    </button>
  </div>
  <div class="flex flex-column flex-grow-1 mt-2" style="height: 310px">
    <app-ai-message-list [messages]="messages" avatarSize="small"></app-ai-message-list>
  </div>
</div>
